<template>
  <v-layout align-center justify-center column class="pagemargin page">
    <v-flex xs12 sm12 md12 align-center>
      <div style="border: black">
        <img
          :src="require('@/assets/colour-logo-transparent-bg.png')"
          style="max-width: 50%; margin-top: 40px"
        />
      </div>
    </v-flex>

    <v-card class="signup-form" width="400" max-height="320">
      <notifications group="existent-user" position="top center" />
      <v-card-title class="title font-weight-regular justify-space-between">
        <span>{{currentTitle}}</span>
        <v-avatar color="primary lighten-2" class="subheading white--text" size="24" v-text="step"></v-avatar>
      </v-card-title>

      <v-window v-model="step">
        <v-window-item :value="1">
          <v-card-text>
            <v-text-field
              v-model.trim="Form.Data.firstName"
              label="First Name"
              solo
              data-vv-name="firstName"
              v-validate="'required|max:30'"
              data-vv-rules="required"
              data-vv-scope="signupForm"
              :error-messages="errors.collect('signupForm.firstName')"
            ></v-text-field>
            <v-text-field
              v-model.trim="Form.Data.lastName"
              label="Last Name"
              solo
              data-vv-name="lastName"
              data-vv-rules="required"
              data-vv-scope="signupForm"
              v-validate="'required|max:30'"
              :error-messages="errors.collect('signupForm.lastName')"
            ></v-text-field>
          </v-card-text>
        </v-window-item>

        <v-window-item :value="2">
          <v-card-text>
            <v-text-field
              v-model.trim="Form.Data.userEmail"
              label="Email"
              solo
              data-vv-name="userEmail"
              data-vv-rules="required"
              data-vv-scope="signupForm"
              v-validate="'required|max:30'"
              :error-messages="errors.collect('signupForm.userEmail')"
            ></v-text-field>
            <v-text-field
              v-model.trim="Form.Data.password"
              solo
              label="Password"
              type="password"
              data-vv-name="password"
              data-vv-rules="required"
              data-vv-scope="signupForm"
              v-validate="'required|max:12'"
              :error-messages="errors.collect('signupForm.password')"
            ></v-text-field>
            <span
              class="caption grey--text text--darken-1"
            >Please enter the email and password for your account</span>
            <!-- <table border="0">
              <tr>
                <td valign="middle">
                  <v-checkbox
                    hide-details
                    type="checkbox"
                    class="shrink ma-0 pa-0"
                    v-model="Form.terms"
                    data-vv-name="terms"
                    data-vv-rules="required"
                    data-vv-scope="signupForm"
                    v-validate="'required'"
                    :error-messages="errors.collect('signupForm.terms')"
                  ></v-checkbox>
                </td>
                <td valign="middle">
                  Please accept our
                  <u>Terms & Conditions</u>
                </td>
              </tr>
              <span class="caption" v-show="errors.has('terms')">{{ errors.first(`'terms'`) }}</span>
            </table> -->
          </v-card-text>
        </v-window-item>

        <v-window-item :value="3">
          <div v-if="isValid == true" class="pa-3 text-xs-center">
            <div v-if="userExists == 0">
              <h4 class="title font-weight-light mb-2">Verify your email for confirmation</h4>
              <span class="caption grey--text">Thanks for signing up!</span>
            </div>
            <div v-if="userExists == 1">
              <h4 class="title font-weight-light mb-2">The user already exists</h4>
              <span class="caption grey--text">Please use a different email address</span>
            </div>
          </div>
          <div v-if="isValid == false">
            <h4 class="title font-weight-light mb-2">The fields cannot be empty</h4>
            <span class="caption grey--text">Please fill in the form!</span>
          </div>
        </v-window-item>
      </v-window>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn :disabled="step === 1" round @click="step--">Back</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="this.step === 2"
          @click="SubmitForm('signupForm'), step++"
          color="primary"
          round
          block
          class="white--text"
        >Submit</v-btn>
        <v-btn
          v-if="this.step !==2"
          :disabled="step === 3"
          outline
          color="primary"
          round
          @click="step++"
        >Next</v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>


<script>
import { mapState } from "vuex";
import Vue from "vue";
import axios from "axios";
import CRUD from "@/firebase/crud";
import { async } from "q";
import { setTimeout } from "timers";

export default {
  $_veeValidate: { validator: "new" }, // Creates new Validator for Form based on veeValidate plugin
  data: function() {
    return {
      step: 1,
      Debug: true,
      dictionary: {}, // Used for Validation Helpers
      isValid: false,
      userExists: 0,
      Form: {
        progress: false, // State of Progress of Submission
        disabled: false, // Used to Disable the Form when Submission in Progress
        error: null,
        terms: "",
        Data: {
          userEmail: "",
          emailDomain: "",
          firstName: "",
          lastName: "",
          confirmPin: "",
          password: "",
          portalID: [],
          userLevel: "",
          sponsorID: "",
          isSponsor: ""
        }
      },
      Organisation: {
        ID: "1111",
        emailDomain: "vindico.net",
        name: "Vindico"
      }
    };
  },
  mounted() {
    //console.log("QUERY=" + this.$route.query.sID + " " + this.$route.query.ul);
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      FirebaseFunctionsURL: state => state.FirebaseFunctionsURL,

      currentTitle() {
        switch (this.step) {
          case 1:
            return "Sign-up";
          case 2:
            return "Create a password";
          default:
            return "Account created";
        }
      }
    })
  },
  methods: {
    ResetForm() {
      // Reset the Form to default values
      this.Form.Data = {
        userEmail: "",
        emailDomain: "",
        firstName: "",
        lastName: "",
        confirmPin: "",
        password: "",
        terms: "",
        userLevel: "",
        sponsorID: "",
        isSponsor: "",
        portalID: []
      };

      this.$validator.pause();
      this.$nextTick(() => {
        this.$validator.errors.clear();
        this.$validator.fields.items.forEach(field => field.reset());
        this.$validator.fields.items.forEach(field =>
          this.errors.remove(field)
        );
        this.$validator.resume();
      });
    },
    SubmitForm: async function(scope) {
      // Submit the form based on validation
      if (this.Debug === true) {
        // console.log("Submitting Form");
      }
      this.$validator
        .validateAll(scope)
        .then(result => {
          // console.log("Result = " + result);
          if (result) {
            this.isValid = true;
            var email = this.Form.Data.userEmail;
            this.Form.Data.emailDomain = email.replace(/.*@/, "");
            this.Form.disabled = false;
            this.Form.progress = true;
            this.Form.Data.fullName =
              this.Form.Data.firstName + " " + this.Form.Data.lastName;

            //take the user level and sponsorID from route query and set them on form
            var routeUserLevel = this.$route.query.ul;
            var routeSponsorID = this.$route.query.sid;            
            var routePortalID = this.$route.query.pid;

            this.Form.Data.portalID.push(routePortalID);

            if (routeUserLevel) {
              let userLevelDocument = Promise.resolve(
                CRUD.GetDocumentByID("lookups", routeUserLevel)
              );
              userLevelDocument.then(response => {
                if (routeSponsorID) {
                  this.Form.Data.sponsorID = routeSponsorID;
                  this.Form.Data.isSponsor = true;
                } else {
                  this.Form.Data.isSponsor = false;
                }
                this.Form.Data.userLevel = response.data.value;
              });
            } else {
              console.log("Undefined user level ID");
            }

            //Check the user email
            axios
              .get(
                this.FirebaseFunctionsURL +
                  "checkOrganisation?emailDomain=" +
                  this.Form.Data.emailDomain
              )
              .then(response => {
                // console.log(
                //   "RESULT: " + JSON.stringify(response, null, 2)
                // );

                if (response.data.result === true) {
                  // console.log("Valid username from organisation");

                  var docID = 0;
                  var t = this;
                  (async () => {
                    await this.$firebase.db
                      .collection("users")
                      .where("userEmail", "==", this.Form.Data.userEmail)
                      .get()
                      .then(function(querySnapshot) {
                        querySnapshot.forEach(function(doc) {
                          t.userExists = 1;
                          docID = doc.id;
                          // console.log("user exists - in = " + t.userExists);
                          //console.log(doc.id, "=> ", doc.data());
                        });

                        // console.log("user exists - out = " + t.userExists);
                        if (t.userExists === 0) {
                          t.$firebase.auth
                            .createUserWithEmailAndPassword(
                              t.Form.Data.userEmail,
                              t.Form.Data.password
                            )
                            .then(user => {
                              // console.log(
                              //                                "User Details = " + JSON.stringify(user)
                              //);
                              t.Form.Data.passwordResetCode = "0";
                              t.Form.Data.emailVerificationCode = "123456789";
                              t.Form.Data.emailVerified = false;
                              t.Form.Data.userID = user.user.uid;
                              t.$firebase.db
                                .collection("users")
                                .doc(user.user.uid)
                                .set(t.Form.Data)
                                .then(Result => {
                                  if (t.Debug === true) {
                                    // console.log(
                                    //   t.FirebaseFunctionsURL +
                                    //     "verifyEmail?emailVerificationCode=" +
                                    //     t.Form.Data.emailVerificationCode +
                                    //     "&id=" +
                                    //     t.Form.Data.userID
                                    // );
                                    // axios
                                    //   .get(
                                    //     t.FirebaseFunctionsURL +
                                    //       "verifyEmail?emailVerificationCode=" +
                                    //       t.Form.Data.emailVerificationCode +
                                    //       "&id=" +
                                    //       t.Form.Data.userID
                                    //   )
                                    //   .then(response => {
                                    //     if (response.data.result === true) {
                                    //       console.log(
                                    //         "Verify email successfully sent"
                                    //       );
                                    //     } else {
                                    //       console.log(
                                    //         "The verify email was not sent"
                                    //       );
                                    //     }
                                    //   });
                                  }
                                })
                                .catch(err => {
                                  if (t.Debug === true) {
                                    // console.log(err);
                                  }
                                });
                            })
                            .catch(err => {
                              if (t.Debug === true) {
                                if (err.code == "auth/email-already-in-use")
                                  Vue.notify({
                                    group: "existent-user",
                                    title: "Important message",
                                    text: "Existent user"
                                  });
                                // console.log(err);
                              }
                            });
                        } else {
                          //the user already exists - do nothing
                        }
                      });
                  })();
                  //the execution time is too long; at the moment it allows duplicates
                } else {
                  // console.log("Invalid username from organisation");
                }
              });

            // Add default fields before sumission
          } else {
            // Do nothing as failed validation - errors shown automatically
          }
        })
        .catch(() => {
          if (this.Debug === true) {
            // console.log("Errors!!" + this.errors.all());
          }
        });
    }
  },
  mounted() {
    if (this.Debug === true) {
      // console.log("Custom Debugger Enabled");
    }
    this.$validator.localize("en", this.dictionary); // Create Validator based on Dictionary
  }
};
</script>

<style>
.signup-form {
  margin: 4%;
  padding: 1%;
  border-radius: 10px !important;
}
</style>